document.addEventListener("DOMContentLoaded", function () {
  // TODO remove `.no-scientific-notation` class, `<.input type="number" />` now uses `Decimal` to prevent
  // scientific notation.
  // Some values are incorrectly stored (e.g. 3.2999999999999998 is stored instead of 3.3), so truncating
  // is necessary. Use `.js-input-number-to-fixed-2` class if necessary for compatibility, but prefer
  // storing the correct value in the database if possible.
  $(".no-scientific-notation").each(function () {
    if (Number(this.value) != 0) {
      let newValue = Number(this.value).toFixed(2);
      this.value = newValue;
      $(this).attr("value", newValue);
    }
  });

  document.querySelectorAll(".js-input-number-to-fixed-2").forEach(function (el) {
    const value = el.valueAsNumber ? el.valueAsNumber : el.value;
    const newValue = _.round(value, 2);
    el.valueAsNumber ? (el.valueAsNumber = newValue) : (el.value = newValue);
  });
});
